var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DialogSlot",
    {
      ref: "set-vendor-modal",
      attrs: {
        id: _vm.slotId,
        modalBtn: _vm.$t("action.setEmail4Contractor"),
        modalBtnClass: "btn--darkblue",
        modalHeader: _vm.$t("settings.user.vendor.setContractorEmail"),
        showCloseBtn: false,
        beforeOpenModal: _vm.beforeOpenModal,
        afterCloseModal: _vm.resetData,
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _c(
            "label",
            {
              staticClass: "required-flag",
              attrs: { for: "settings-vendors-add-number" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("settings.user.vendor.username")) +
                  " (" +
                  _vm._s(_vm.$t("settings.user.vendor.email")) +
                  ")\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.username,
                expression: "username",
              },
              {
                name: "fusioninputcheck",
                rawName: "v-fusioninputcheck",
                value: {
                  type: "string",
                  patternOnly: _vm.validateUsername,
                  classes: "tooltip-class",
                  tip: _vm.usernameTip,
                  required: true,
                },
                expression:
                  "{\n        type: 'string',\n        patternOnly: validateUsername,\n        classes: 'tooltip-class',\n        tip: usernameTip,\n        required: true\n      }",
              },
            ],
            class: _vm.emailErrClass,
            attrs: {
              type: "text",
              pattern: "email",
              placeholder: _vm.$i18n.t("settings.user.vendor.email"),
            },
            domProps: { value: _vm.username },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.username = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "required-flag",
              attrs: { for: "settings-vendors-add-number" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("settings.user.vendor.number")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("HKLSelect", {
            staticClass: "align-center",
            class: _vm.extIdErrClass,
            attrs: {
              value: _vm.companyToSetId,
              options: _vm.companyNumberHklOptions,
              showSearch: true,
              placeholder: "",
            },
            on: { change: _vm.onCompanyChange },
          }),
          _vm._v(" "),
          _c("label", { staticClass: "required-flag" }, [
            _vm._v(_vm._s(_vm.$t("company.basic.companyName"))),
          ]),
          _vm._v(" "),
          _c("HKLSelect", {
            staticClass: "align-center",
            class: _vm.companyErrClass,
            attrs: {
              value: _vm.companyToSetId,
              options: _vm.companyNameHklOptions,
              showSearch: true,
              placeholder: "",
            },
            on: { change: _vm.onCompanyChange },
          }),
          _vm._v(" "),
          _c("label", { staticClass: "required-flag" }, [
            _vm._v(_vm._s(_vm.$t("company.basic.departmentName"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("HKLMultiSelect", {
                staticClass: "align-center multi-value",
                class: _vm.departmentErrClass,
                attrs: {
                  options: _vm.departmentHklOptions,
                  showSearch: false,
                  placeholder: "",
                },
                model: {
                  value: _vm.selectedDepartmentIds,
                  callback: function ($$v) {
                    _vm.selectedDepartmentIds = $$v
                  },
                  expression: "selectedDepartmentIds",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "required-flag",
              attrs: { for: "settings-vendors-add-contactAdmin" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("settings.user.vendor.contactAdminName")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.contactAdmin,
                expression: "contactAdmin",
              },
              {
                name: "fusioninputcheck",
                rawName: "v-fusioninputcheck",
                value: {
                  type: "string",
                  pattern: _vm.regex.string,
                  classes: "tooltip-class",
                },
                expression:
                  "{\n        type: 'string',\n        pattern: regex.string,\n        classes: 'tooltip-class'\n      }",
              },
            ],
            attrs: {
              id: "settings-vendors-add-contactAdmin",
              type: "text",
              placeholder: _vm.$i18n.t("settings.user.vendor.contactAdminName"),
              required: "",
            },
            domProps: { value: _vm.contactAdmin },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.contactAdmin = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "required-flag",
              attrs: { for: "settings-vendors-add-contactPhone" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("settings.user.vendor.contactPhone")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.contactPhone,
                expression: "contactPhone",
              },
              {
                name: "fusioninputcheck",
                rawName: "v-fusioninputcheck",
                value: {
                  type: "string",
                  pattern: _vm.regex.phone,
                  classes: "tooltip-class",
                  tip: _vm.tips.phone,
                },
                expression:
                  "{\n        type: 'string',\n        pattern: regex.phone,\n        classes: 'tooltip-class',\n        tip: tips.phone\n      }",
              },
            ],
            attrs: {
              id: "settings-vendors-add-contactPhone",
              type: "number",
              placeholder: _vm.$i18n.t("settings.user.vendor.contactPhone"),
            },
            domProps: { value: _vm.contactPhone },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.contactPhone = $event.target.value
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
        _c(
          "div",
          { staticClass: "row align-right nav_btn" },
          [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: {
                  id: "tender-general-contractData-cancel",
                  type: "button",
                },
                on: { click: _vm.closeModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c("HKLButton", {
              attrs: { action: "confirm", color: "orange" },
              on: {
                click: function () {
                  return _vm.addVendor()
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }